import LoginBody from './LoginBody';

export default LoginBody;
